<script lang="ts">
    import cn from 'classnames';

    import { isFunction } from '@components/utils/type/checker';
    import { Font, FontTypes } from '@uikit/font';
    import { Link, LinkTypes } from '@uikit/link';

    import s from './form-bottom.module.css';

    export let linkText: string;
    export let headerText: string;
    export let classes = '';
    export let onClick: (() => void) | null = null;

    function toggleMode() {
        if (isFunction(onClick)) {
            onClick();
        }
    }
</script>

<div class={cn(s.root, classes)} data-testid="formBottom">
    <div
        class={cn(s.action)}
        on:click={toggleMode}
        on:keypress={toggleMode}
        role="button"
        tabindex="0"
        aria-pressed="false"
    >
        <div>
            <Font
                type={FontTypes.Type.body}
                tagName={FontTypes.TagName.span}
                color={FontTypes.Color.Secondary}
                attrs={{ 'data-testid': 'text' }}
            >
                {headerText}
            </Font>
            <Link
                color={LinkTypes.Color.Secondary}
                isBold
                isUnderline
                attrs={{ 'data-testid': 'link' }}
            >
                {linkText}
            </Link>
        </div>
    </div>

    <slot />
</div>
